import { useLayout } from '@/mastodon/hooks/useLayout';
import { Search } from 'mastodon/features/compose/components/search';
import { useIdentity } from 'mastodon/identity_context';

import { ThemeToggle } from './theme_toggle';

export const ComposePanel: React.FC = () => {
  const { singleColumn } = useLayout();
  const { signedIn } = useIdentity();

  return (
    <div className='compose-panel'>
      <div className='compose-panel__utility-row'>
        {signedIn && <Search singleColumn={singleColumn} />}
        <ThemeToggle />
      </div>
    </div>
  );
};
